module.exports = __webpack_public_path__ + "593a3d53/img/splash-icon.07a7c465.svg";